import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { IFlightType } from 'common/types';
import { SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useSearch } from '../../hooks/search';

import { listOfFlightTypes } from '../../common/initialItems';
import ISelectFlightTypeDesktop from './types';

const SelectFlightTypeDesktop: React.FC<ISelectFlightTypeDesktop> = ({
  isMobile = false,
}: ISelectFlightTypeDesktop) => {
  const { flightType, setFlightType } = useSearch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(
    listOfFlightTypes[flightType]
  );
  const [selectedItemValue, setSelectedItemValue] = useState(flightType);

  const { t } = useTranslation('flightSearch');

  const handleSelectItem = useCallback(
    (item) => {
      localStorage.removeItem('exploreWorld');
      setSelectedItem(item);
      setSelectedItemValue(item.value);
      setFlightType(item.value);
    },
    [setFlightType]
  );
  const arrayOfItems = Object.keys(listOfFlightTypes) as IFlightType[];

  useEffect(() => {
    if (
      selectedItem.value === selectedItemValue &&
      selectedItemValue !== flightType
    ) {
      setSelectedItem(listOfFlightTypes[flightType]);
    }
  }, [flightType, selectedItem, selectedItemValue]);

  return !isMobile ? (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={() => setDropdownOpen((prevState) => !prevState)}
      className="smls-dropdown-button"
    >
      <DropdownToggle id="drop_fligthType">
        {selectedItem.icon}
        {t(selectedItem.translationKey)}
        <i className="material-icons">
          {dropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down'}
        </i>
      </DropdownToggle>
      <DropdownMenu>
        {arrayOfItems.map((item) => (
          <DropdownItem
            onClick={() => handleSelectItem(listOfFlightTypes[item])}
            id={listOfFlightTypes[item].id}
            data-testid={listOfFlightTypes[item].id}
            key={listOfFlightTypes[item].value}
            className={
              selectedItem.value === listOfFlightTypes[item].value
                ? 'selected-item'
                : ''
            }
          >
            {t(listOfFlightTypes[item].translationKey)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  ) : (
    <div className="flight-type-selector-mobile">
      <div className="flight-type-selector-content">
        {arrayOfItems.map((item) => (
          <SmlsButton
            id={`SelectFlightTypeDesktop-select-item-${listOfFlightTypes[item].value}`}
            onClick={() => handleSelectItem(listOfFlightTypes[item])}
            type="button"
            color="hyperlink"
            className={
              selectedItem.value === listOfFlightTypes[item].value
                ? 'active'
                : ''
            }
            key={listOfFlightTypes[item].value}
            text={t(listOfFlightTypes[item].translationKey)}
          />
        ))}
      </div>
    </div>
  );
};
export default SelectFlightTypeDesktop;
